<nav class="flex flex-col gap-3 h-full bg-iota-sidebar text-white relative overflow-y-auto overflow-x-hidden">
    <div class="flex">
        <div class="w-full p-6 pb-2 flex mt-2">
            <img
                [routerLink]="['/']"
                [src]="environment.basePathCdn + '/api/v2/assets/images/logo-chaemp-light.svg'"
                class="h-10 ml-3.5 cursor-pointer"
                alt="Logo image"
            />
        </div>
        <div class="absolute right-0 top-0 mt-6 z-10 pb-2 px-4" [ngClass]="{ 'bg-[#363636] shadow-lg rounded-lg': languagesDropdownOpen }">
            <div class="flex items-center justify-end ml-2 mt-3.5">
                <iota-icon icon="globe-alt" class="mr-2" [size]="1.25"></iota-icon>
                <p class="uppercase">{{ (selectedLanguage$ | ngrxPush)?.countryCode }}</p>
                <div tabindex="0" class="px-2 pt-1" (click)="toggleLanguagesDropdown()">
                    <iota-icon icon="chevron-down" class="stroke-[2] text-white"> </iota-icon>
                </div>
            </div>

            <ul *ngIf="languagesDropdownOpen" tabindex="0" class="flex shadow menu dropdown-content mt-2">
                <li
                    *ngFor="let language of languages$ | ngrxPush"
                    class="flex mb-3 hover:bg-iota w-full pb-2 rounded-lg pl-2 items-center pt-1"
                    (click)="changeLanguage(language)"
                >
                    <a class="no-bg">
                        <span class="hidden lg:block capitalize text-xs font-normal">{{ language.displayName }}</span>
                        <span class="hidden lg:block uppercase text-xs pl-2 font-normal">{{ language.countryCode }}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <div class="mx-5 py-3 border-y border-y-[#363636] flex flex-row items-center gap-5" *ngIf="user$ | ngrxPush as user">
        <div class="cursor-default rounded-lg bg-primary h-[40px] w-[40px] text-primary-content flex justify-center items-center">
            <span>{{ user?.firstName | slice: 0 : 1 }}</span>
        </div>
        <div class="flex flex-col text-sm">
            <p>{{ user?.firstName }} {{ user?.lastName }}</p>
            <p>{{ user?.username }}</p>
        </div>
        <div class="flex-1"></div>
        <div (click)="doLogout()" class="cursor-pointer mt-1">
            <iota-icon icon="arrow-right-on-rectangle" class="stroke-[2]" size="1.25"> </iota-icon>
        </div>
    </div>

    <div class="overflow-y-auto overflow-x-hidden scrollbar-right">
        <ul class="menu menu-compact px-4 gap-2">
            <ng-container *ngFor="let menuEntry of menuEntries$ | async; let i = index">
                <li
                    [ngClass]="{
                        'collapse collapse-arrow': menuEntry?.children?.length > 0,
                        'collapse-open': expandedEntries?.includes(menuEntry.key),
                        'collapse-close': !expandedEntries?.includes(menuEntry.key)
                    }"
                    class="w-full bg-inherit"
                    tabindex="0"
                    *ngIf="!menuEntry?.hidden"
                >
                    <!-- Entry with children -->
                    <ng-container *ngIf="menuEntry?.children?.length > 0">
                        <!-- Entry with route -->
                        <a
                            [routerLink]="[menuEntry?.route]"
                            [routerLinkActive]="['!text-primary', '!fill-primary']"
                            [routerLinkActiveOptions]="{ exact: false }"
                            class="!bg-inherit collapse-title fill-white"
                            (click)="toggleMenuEntryExpand(menuEntry.key)"
                            *ngIf="!!menuEntry?.route"
                        >
                            <div class="flex">
                                <iota-icon *ngIf="!!menuEntry?.heroicon" [icon]="menuEntry?.heroicon" size="1.25"> </iota-icon>
                                <iota-icon *ngIf="!!menuEntry?.flaticon" [flaticon]="menuEntry?.flaticon" size="1.25"> </iota-icon>
                            </div>
                            <span class="whitespace-normal text-[16px]">{{ menuEntry?.label }}</span>
                        </a>
                        <!-- Entry without route -->
                        <a class="!bg-inherit collapse-title" (click)="toggleMenuEntryExpand(menuEntry.key)" *ngIf="!menuEntry?.route">
                            <div class="flex">
                                <iota-icon *ngIf="!!menuEntry?.heroicon" [icon]="menuEntry?.heroicon" size="1.25"> </iota-icon>
                                <iota-icon *ngIf="!!menuEntry?.flaticon" [flaticon]="menuEntry?.flaticon" size="1.25"> </iota-icon>
                            </div>
                            <span class="whitespace-normal text-[16px]">{{ menuEntry?.label }}</span>
                        </a>
                        <ul class="collapse-content w-full bg-[#363636]" [ngClass]="{ '!pb-2': expandedEntries?.includes(menuEntry.key) }">
                            <ng-container *ngFor="let child of menuEntry?.children">
                                <li class="bg-inherit mt-2" *ngIf="!child?.hidden">
                                    <a
                                        class="!bg-inherit fill-white"
                                        [routerLink]="[child?.route]"
                                        [routerLinkActive]="['!text-primary', '!fill-primary']"
                                        [routerLinkActiveOptions]="{ exact: false }"
                                    >
                                        <div class="flex">
                                            <iota-icon *ngIf="!!child?.heroicon" [icon]="child?.heroicon" size="1.25"> </iota-icon>
                                            <iota-icon *ngIf="!!child?.flaticon" [flaticon]="child?.flaticon" size="1.25"> </iota-icon>
                                        </div>
                                        <span class="whitespace-normal text-[16px]">{{ child?.label }}</span>
                                    </a>
                                </li>
                            </ng-container>
                        </ul>
                    </ng-container>

                    <!-- Entry without children -->
                    <ng-container *ngIf="!menuEntry?.children?.length">
                        <a
                            [routerLink]="[menuEntry?.route]"
                            [routerLinkActive]="['!text-primary', '!fill-primary']"
                            [routerLinkActiveOptions]="{ exact: false }"
                            class="!bg-inherit fill-white"
                        >
                            <div class="flex">
                                <iota-icon *ngIf="!!menuEntry?.heroicon" [icon]="menuEntry?.heroicon" size="1.25"> </iota-icon>
                                <iota-icon *ngIf="!!menuEntry?.flaticon" [flaticon]="menuEntry?.flaticon" size="1.25"> </iota-icon>
                            </div>
                            <span class="whitespace-normal text-[16px]">{{ menuEntry?.label }}</span>
                        </a>
                    </ng-container>
                </li>
            </ng-container>
        </ul>
    </div>

    <footer class="mt-auto py-4 px-5 text-[#C2C2C2] border-t border-t-[#363636] text-xs flex flex-col">
        <div class="flex flex-row gap-1">
            <p>Made with</p>
            <iota-icon icon="heart" class="stroke-[2] text-iota" variation="solid" size="1.25"> </iota-icon>
            <p>© {{ year }} INH GmbH</p>
        </div>
        <div class="flex flex-row gap-1">
            <a class="cursor-pointer" target="_blank" [href]="(basePortalUrl$ | ngrxPush) + '/imprint'" i18n>Imprint</a>
            <span>|</span>
            <a class="cursor-pointer" target="_blank" [href]="(basePortalUrl$ | ngrxPush) + '/privacy'" i18n>Privacy</a>
            <span>|</span>
            <a class="cursor-pointer" target="_blank" [href]="(basePortalUrl$ | ngrxPush) + '/tos'" i18n>ToS</a>
        </div>
    </footer>
</nav>
